import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { PaymentMethod } from "../../../../graphql/schema";
import { AsyncImg } from "../../../../components/async-img/AsyncImg";
import { DigitalProductBase } from "../../../../components/digital-product-base/DigitalProductBase";
import {
  AddToCartSelectorProductPackage,
  AddToCartSelectorProps,
} from "../../../../components/add-to-cart-selector/AddToCartSelector";
import { OfferSubmitMethod } from "../../../../components/digital-product-exclusive-offer/offers/Offers";
import { Button } from "../../../../components/button/Button";
import { Color } from "../../../../services/buttonLinkConstants";
import { Modal, ModalKind } from "../../../../components/modal/Modal";
import { PanelWidth } from "../../../../components/panel/Panel";
import { Link } from "../../../../components/link/Link";

import styles from "./the-view.module.scss";

export interface TheViewExclusiveOfferMembership {
  id: string;
  labelText?: string | null;
  datePurchased: string;
  eurPrice: string;
  dagPrice: string;
}

export interface TheViewProps extends Pick<AddToCartSelectorProps, "hasAccess"> {
  className?: string;
  publicUrl?: string;
  packages?: AddToCartSelectorProductPackage[] | null;
  detail?: string;
  exclusiveOffer?: {
    dateStart: Date;
    dateEnd: Date;
    expiresInMS: number;
    memberships: TheViewExclusiveOfferMembership[];
    dagsBalance: number;
    availablePaymentMethods: PaymentMethod[];
    onSubmit(method: OfferSubmitMethod, membershipIds: string[], totalPrice: string): Promise<void>;
  };
}

export const TheView: React.FC<TheViewProps> = ({
  className,
  publicUrl,
  packages,
  detail,
  exclusiveOffer,
  ...props
}) => {
  const [t] = useTranslation();
  //   const [isExclusiveOfferOpen, setIsExclusiveOfferOpen] = useState(false);
  //   const [selectedMembershipIds, setSelectedMembershipIds] = useState<string[]>([]);
  const [isDealsModalOpen, setIsDealsModalOpen] = useState(false);

  //   function isMembershipChecked(row: { id: string }) {
  //     return selectedMembershipIds.includes(row.id);
  //   }

  //   function handleMembershipChecked(membershipId: string) {
  //     setSelectedMembershipIds(
  //       selectedMembershipIds.includes(membershipId)
  //         ? selectedMembershipIds.filter((id) => id !== membershipId)
  //         : [...selectedMembershipIds, membershipId],
  //     );
  //   }

  //   const membershipTotalInEur = (exclusiveOffer?.memberships ?? [])
  //     .filter(isMembershipChecked)
  //     .reduce((total, row) => total + Number(row.eurPrice), 0);
  //   const membershipTotalInDag = (exclusiveOffer?.memberships ?? [])
  //     .filter(isMembershipChecked)
  //     .reduce((total, row) => total + Number(row.dagPrice), 0);

  return (
    <DigitalProductBase
      title={t("The View")}
      logo={<AsyncImg className={className} src="/images/TheViewLogo.svg" />}
      publicUrl={publicUrl}
      detail={detail ?? ""}
      price={t("No monthly fees")}
      exclusiveOffer={undefined}
      onExclusiveOfferClick={() => {}}
      exclusiveOfferExpiryDate={exclusiveOffer?.dateEnd}
      exclusiveOfferTimeLeftMS={exclusiveOffer?.expiresInMS}
      producerName="The View BV / <br/>The View Meta Technologies LLC"
    >
      {/* <AddToCartSelector
        className={styles["access-product-link"]}
        labelClassName={styles["link-label"]}
        packages={packages || []}
        modalPanelProps={{
          title: t("Select the packages"),
          caption: t(
            "The View has {{count}} different packages, select the one(s) that you want and click “Add to cart”. You can adjust the quantity of the packages inside the cart, on the next page.",
            { count: packages?.length },
          ),
          label: "The View",
        }}
        hasAccess={props.hasAccess}
      /> */}

      {/* {exclusiveOffer && isExclusiveOfferOpen && (
        <DigitalProductExclusiveOfferModal
          label={t("The View")}
          description={t(
            "Below you can find The View memberships you are eligible to purchase again by using dagcoin payments. This exclusive offer is <strong>ending in {{timeLeft}}</strong>, in {{date}}.",
            {
              date: formatLocaleDate(exclusiveOffer.dateEnd, i18n.language),
              timeLeft: timeLeft(exclusiveOffer.expiresInMS, t),
            },
          )}
          close={() => setIsExclusiveOfferOpen(false)}
          onMembershipChecked={handleMembershipChecked}
          memberships={exclusiveOffer.memberships.map((row) => ({ ...row, isChecked: isMembershipChecked(row) }))}
          totalPriceInEur={membershipTotalInEur}
          totalPriceInDags={membershipTotalInDag}
          dagsBalance={exclusiveOffer.dagsBalance}
          availablePaymentMethods={exclusiveOffer.availablePaymentMethods}
          onSubmit={(method) => exclusiveOffer.onSubmit(method, selectedMembershipIds, membershipTotalInDag.toString())}
        />
      )} */}
      <Button
        className={styles["access-product-link"]}
        borderRadius="SMALL"
        color={Color.DARK_BLUE}
        fontSize={18}
        // style={{ width: 170, marginLeft: 10 }}
        onClick={() => setIsDealsModalOpen(true)}
        style={{
          width: 142,
          fontWeight: 500,
          fontSize: "12px !important",
          padding: "2px !important",
          margin: "2px !important",
          minHeight: "40px !important",
        }}
      >
        <span className={styles["link-label"]}>{t("Read more")}</span>
      </Button>
      <Modal
        isOpen={isDealsModalOpen}
        close={() => setIsDealsModalOpen(false)}
        kind={ModalKind.PRIMARY}
        panelProps={{
          imagePath: "/images/TheViewLogo.svg",
          width: PanelWidth.SMALL,
          title: t("View Meta Technologies LLC"),
          caption: t("View Meta Technologies LLC"),
          label: t("View Meta Technologies LLC"),
          titleClassName: styles["modal-title"],
          captionClassName: styles["modal-caption"],
        }}
      >
        <div
          style={{
            maxWidth: "700px",
            border: "1px solid #ddd",
            backgroundColor: "#fafafa",
            padding: "7px 15px",
            marginTop: "25px",
            lineHeight: "1.5em",
          }}
        >
          <div className={styles["responsive-container"]}>
            <div className={styles.text} style={{ width: "100%", padding: "15px" }}>
              <h4>Special SCR Burn For View Customers - Deposit Into Licensed And Regulated Broker</h4>

              <p style={{ marginTop: "10px", marginBottom: "10px" }}>
                You can over 50% of your deposit at the broker with SCR for your 12x amplified trading accounts!
                <br />
                Simply burn your SCR (Store Credit) received for your membership, and you'll receive up to your full
                membership value in D2T promotional balance to use as part of your deposit - 50% from D2T, 50% in
                fiat/crypto
              </p>
              <p
                style={{
                  marginTop: "20px",
                  marginBottom: "10px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <span style={{ marginTop: "10px" }}>1 D2T gives 1 USD deposit in TAG Markets.</span>
                <Link
                  to="/account/the-view-scr-burn"
                  shape="RECT"
                  height="SMALL"
                  weight="MEDIUM"
                  color="DARK_BLUE"
                  borderRadius="SMALL"
                  fontSize={18}
                  style={{
                    width: 162,
                    fontSize: "12px !important",
                    padding: "2px !important",
                    margin: "2px !important",
                    minHeight: "40px !important",
                  }}
                >
                  <span>{t("How it Works")}</span>
                </Link>
              </p>
              <h4 style={{ marginTop: "60px" }}>General Info</h4>
              <p style={{ marginTop: "10px", marginBottom: "10px" }}>
                When purchasing any of the View memberships you became the customer of The View B.V., which in turn
                transferred the View platform to View Meta Technologies LLC.
              </p>

              <p style={{ marginTop: "10px", marginBottom: "10px" }}>
                Success Factory was the company providing marketing service to The View, earning a marketing fee from
                every membership sale. The majority of the marketing fee was used to pay the marketing commissions to
                the affiliates. The other part from the membership price was forwarded to The View B.V. for the
                development of the product.
              </p>

              <p style={{ marginTop: "10px", marginBottom: "10px" }}>
                According to the terms and conditions of Success Factory, which everybody who purchased a View
                membership agreed to, the responsibility and delivery of the View product is with the product company,
                The View.
              </p>

              <p style={{ marginTop: "10px", marginBottom: "10px" }}>
                Even though the income for Success Factory was the smallest part from sales of the product (compared to
                affiliate commissions and income to the View), both Success Factory and SF Suite want the customers to
                have a good experience and get value out of using the platform, and have taken several steps to
                compensate the under-delivery of the product by The View.
              </p>

              <p style={{ marginTop: "10px", marginBottom: "10px" }}>What you have received:</p>
              <ul style={{ paddingLeft: "20px" }}>
                <li>
                  Shop Credits (SCR) equally to the purchase value of your View memberships, credited to your account
                  already (can be used on current and upcoming products and services)
                </li>
                <li>
                  Homnifi store credits in the amount equal to the purchase value of your View memberships (valid 18
                  months, expiry 07.2025, usable for software and hardware sold on their platform)
                </li>
                <li>LHO tokens that give you ownership and revenue share from LH projects</li>
                <li>
                  Tokenized ownership and revenue share of upcoming social media platform (will be gifted, not possible
                  to purchase)
                </li>
                <li>
                  Tokenized ownership and revenue share of upcoming VR app (TravelView) (will be gifted, not possible to
                  purchase)
                </li>
                <li>Additional token airdrops</li>
              </ul>

              <p style={{ marginTop: "10px", marginBottom: "10px" }}>
                For example if you purchased a 500 View membership, you have already received:
              </p>
              <ul style={{ paddingLeft: "20px" }}>
                <li>500 SCR to be used on this platform (for yourself or someone else)</li>
                <li>500 USD of balance on Homnifi platform (had options to use for yourself or someone else)</li>
                <li>1000 LHO tokens</li>
                <li>Future ownership in two more platforms (including revenue share)</li>
              </ul>

              <p style={{ marginTop: "10px", marginBottom: "10px" }}>
                The store credits combined are already 2x the value of your product purchase. On top of this you will
                have additional value and income coming from the platforms that are being built. Plus the different
                airdrops you are receiving thanks to being part of the community. Additionally, the SCR you received can
                also be used as capital at a brokerage firm, where members from the community have been able to grow
                their capital more than 100% over the past couple of months. Altogether, significantly more benefits
                than the purchase made.
              </p>
            </div>
          </div>
        </div>
      </Modal>
    </DigitalProductBase>
  );
};
